import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceTypeProviderService } from '../providers';
import { InvoiceType } from '../enums';

@Pipe({
  name: 'invoiceType',
})
export class InvoiceTypePipe implements PipeTransform {
  private readonly provider = inject(InvoiceTypeProviderService);

  public transform(type: InvoiceType): Observable<string> {
    return this.provider.labelFor(type);
  }
}
